// extracted by mini-css-extract-plugin
module.exports = {"main":"layout_main__y_SsR","skip":"layout_skip__EL38B","skipNav":"layout_skipNav__8AoA2"};